import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexCheckbox',
  setup(__props) {

const DefaultCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/DefaultCheckbox.vue"))
const CustomCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/CustomCheckbox.vue"))
const DefaultRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/DefaultRadio.vue"))
const ImagesCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/ImagesCheckbox.vue"))
const ImagesRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/ImagesRadio.vue"))
const CustumRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/CustumRadio.vue"))
const DefaultSwitches = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/DefaultSwitches.vue"))
const InlineInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/InlineInput.vue"))
const AnimatedButtons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/AnimatedButtons.vue"))
const CheckboxRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/CheckboxRadio.vue"))
const RadioToggle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/RadioToggle.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DefaultCheckbox)),
      _createVNode(_unref(CustomCheckbox)),
      _createVNode(_unref(DefaultRadio)),
      _createVNode(_unref(ImagesCheckbox)),
      _createVNode(_unref(ImagesRadio)),
      _createVNode(_unref(CustumRadio)),
      _createVNode(_unref(DefaultSwitches)),
      _createVNode(_unref(InlineInput)),
      _createVNode(_unref(AnimatedButtons)),
      _createVNode(_unref(CheckboxRadio)),
      _createVNode(_unref(RadioToggle))
    ])
  ]))
}
}

})